var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 27,
    viewBox: "0 0 42 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7624 26.0637H40.2376L25.9955 14.1144L21.3156 18.0468C21.125 18.199 20.8631 18.199 20.6844 18.0468L16.0045 14.1144L1.7624 26.0637ZM25.6859 13.143H25.6978L40.2376 0.936281H1.7624L16.3022 13.143H16.3141L21.006 17.0754L25.6859 13.143ZM26.7338 13.4941L41.0473 25.5137V1.48635L26.7338 13.4941ZM0.952651 1.48635V25.5137L15.2662 13.4941L0.952651 1.48635ZM41.5237 27H0.476325H0.464417H0.452509C0.202438 26.9883 0 26.7893 0 26.5319V0.46814C0 0.210663 0.214346 0 0.476325 0H41.5237C41.7857 0 42 0.210663 42 0.46814V0.479844V26.5202V26.5319C42 26.7893 41.7857 27 41.5237 27Z",
    fill: "white",
    stroke: "#F9F9FA",
    strokeWidth: 0.000110533
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.740ad598d592afb27d83cc0709ea3d10.svg";
export { ForwardRef as ReactComponent };